<template lang="html">
  <div class="sign-out-view view"></div>
</template>

<script>
import { signOut } from '@/amplify/auth';
import { mapActions } from 'vuex';

export default {
  name: 'sign-out',
  methods: {
    ...mapActions('theme', ['resetTheme']),
  },
  async mounted() {
    // Reset theme to light mode before logout (so login page shows correctly)
    this.resetTheme();
    await signOut();
    this.$router.push('/');
  },
};
</script>

<style lang="css" scoped></style>
